export interface ClientError {
  id: string;
  message: string;
  stack?: string;
  timestamp: string;
  source?: string;
  level?: 'error' | 'warning' | 'info';
  category?: string;
}

const ERROR_STORE_KEY = '__pm_client_errors';
const MAX_ERRORS = 200;

export function getStoredErrors(): ClientError[] {
  try {
    return JSON.parse(sessionStorage.getItem(ERROR_STORE_KEY) || '[]');
  } catch { return []; }
}

export function storeErrors(errors: ClientError[]) {
  sessionStorage.setItem(ERROR_STORE_KEY, JSON.stringify(errors.slice(-MAX_ERRORS)));
}

/** Call this from error boundaries or global handlers to push errors */
export function pushClientError(error: { message: string; stack?: string; source?: string; level?: 'error' | 'warning' | 'info'; category?: string }) {
  const errors = getStoredErrors();
  const newError: ClientError = {
    id: crypto.randomUUID(),
    message: error.message,
    stack: error.stack,
    source: error.source,
    level: error.level || 'error',
    category: error.category,
    timestamp: new Date().toISOString(),
  };
  errors.push(newError);
  storeErrors(errors);
  window.dispatchEvent(new CustomEvent('pm-error-update', { detail: newError }));
}

/** Get error count for badge display */
export function getErrorCount(): number {
  return getStoredErrors().length;
}

let installed = false;
export function installGlobalErrorCapture() {
  if (installed) return;
  installed = true;
  window.addEventListener('error', (e) => {
    pushClientError({ message: e.message, stack: e.error?.stack, source: `${e.filename}:${e.lineno}:${e.colno}`, level: 'error', category: 'javascript' });
  });
  window.addEventListener('unhandledrejection', (e) => {
    const msg = e.reason?.message || String(e.reason);
    pushClientError({ message: msg, stack: e.reason?.stack, source: 'unhandledrejection', level: 'error', category: 'promise' });
  });
}
